const init = () => {};
document.addEventListener( 'DOMContentLoaded', function () {
	const detailsElements = document.querySelectorAll(' .brand-tabs details' );
	if ( detailsElements.length > 0 ) {
		detailsElements[0].setAttribute( 'open', 'open' );
	}
	detailsElements.forEach( ( detail ) => {
		detail.addEventListener( 'click', function () {
			// If the clicked details is already open, do nothing
			if ( detail.hasAttribute( 'open' ) ) {
				if ( detail.target.tagName === 'A' ) {
					return;
				}
				event.preventDefault();
				return;
			}
			// If it's not already open, close all other details elements and open the clicked one
			detailsElements.forEach( ( d ) => {
				if ( d !== detail ) {
					d.removeAttribute( 'open' );
				}
			} );
		} );
	} );
} );
// Exports
export { init };
